import "animate.css";
import "@/css/global.css";
import "@/css/swiper-3.4.2.min.css";
import { WOW } from "wowjs";
/*--------------------------WOW.js--------------------------------*/
new WOW({ live: false }).init();
/*------------------------折叠栏----------------------------------*/
var sliderNav = document.querySelector(".slider-nav");
var sliderButton = document.querySelector(".slider-button");
function changeSliderNav(e) {
  if (sliderNav.classList.contains("open")) {
    sliderNav.classList.remove("open");
  } else {
    sliderNav.classList.add("open");
  }
  if (sliderButton.classList.contains("active")) {
    sliderButton.classList.remove("active");
  } else {
    sliderButton.classList.add("active");
  }
}
sliderButton
  ? (sliderButton.onclick = function () {
      changeSliderNav();
    })
  : "";

var sliderLi = document.querySelectorAll(".slider-nav>li");
for (let i = 0; i < sliderLi.length; i++) {
  sliderLi[i].onclick = function () {
    for (var j = 0; j < sliderLi.length; j++) {
      if (sliderLi[j].classList.contains("open")) {
        sliderLi[j].classList.remove("open");
      }
    }
    if (this.classList.contains("open")) {
      this.classList.remove("open");
    } else {
      this.classList.add("open");
    }
  };
}
function changeSliderUlNav(event) {
  this.style.fontWeight = "bold";
}
var toTopBox = document.querySelector(".toTopBox");
var headerNav = document.querySelector(".header-nav");
var headerNavLogo = document.querySelector(".header-nav .logo");
/*------------------------返回顶部----------------------------------*/
function showHeader() {
  //当前屏幕等于多少执行的事件
  var scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  this.scrollTop = scrollTop;
  if (scrollTop > 200) {
    //当屏幕大于541的时候，就显示，小于则不显示
    toTopBox.classList.add("active");
  } else {
    toTopBox.classList.remove("active");
  }
}
window.addEventListener("scroll", showHeader);
// left: 37, up: 38, right: 39, down: 40
var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
var supportsPassive = false;
try {
  window.addEventListener(
    "test",
    null,
    Object.defineProperty({}, "passive", {
      get: function () {
        supportsPassive = true;
      },
    })
  );
} catch (e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent =
  "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}
// call this to Disable
export function disableScroll() {
  window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
  window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
  window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
  window.addEventListener("keydown", preventDefaultForScrollKeys, false);
}

// call this to Enable
export function enableScroll() {
  window.removeEventListener("DOMMouseScroll", preventDefault, false);
  window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
  window.removeEventListener("touchmove", preventDefault, wheelOpt);
  window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
}
export function goToTop() {
  disableScroll();
  var toTopRoll = setInterval(() => {
    var top = document.documentElement.scrollTop;
    var speed = top / 10;
    if (document.documentElement.scrollTop !== 0) {
      document.documentElement.scrollTop -= speed;
    } else {
      enableScroll();
      clearInterval(toTopRoll);
    }
  }, 20);
}
/*---------------导航栏图片加载---------------------------------------*/
document.querySelector(".logoImage")
  ? (document.querySelector(".logoImage").src = require("@/assets/logo.png"))
  : "";
//底部图片加载
document.querySelector(".footer-ewm")
  ? (document.querySelector(
      ".footer-ewm"
    ).src = require("@/assets/image/public-ewm.jpg"))
  : "";
document.querySelector(".footerTel")
  ? (document.querySelector(
      ".footerTel"
    ).src = require("@/assets/image/tel.png"))
  : "";
document.querySelector(".footerAddress")
  ? (document.querySelector(
      ".footerAddress"
    ).src = require("@/assets/image/address.png"))
  : "";
document.querySelector("footer .logoImage")
  ? (document.querySelector(
      "footer .logoImage"
    ).src = require("@/assets/logo.png"))
  : "";
document.querySelector(".am_bootom img")
  ? (document.querySelector(
      ".am_bootom img"
    ).src = require("@/assets/record_icon.png"))
  : "";
//标题图片批量加载
let iconList = Array.from(document.querySelectorAll(".titleIcon"));
if (iconList) {
  iconList.map((item) => {
    item.src = require("@/assets/image/titleIcon.jpg");
  });
}
//置顶功能
document.querySelector(".toTopBox")
  ? (document.querySelector(".toTopBox").onclick = function () {
      goToTop();
    })
  : "";
